// @flow

import moveOrderItem from '../../../Services/moveOrderItem';
import type { MoveOrderItemParams } from '../../../types';

export default (params: MoveOrderItemParams) => async (dispatch: Function) => dispatch(moveOrderItem(params))